/* istanbul ignore file - need to fix flakey tests */
import { EditPartsCategoriesCategoryNameInput } from '@partful/pages/manage-product/parts-categories/ui/EditPartsCategoriesCategoryNameInput';
import { CategoryNode } from '@services/productInventory';
import type { MRT_ColumnDef, MRT_Row } from 'material-react-table';
import { useMemo } from 'react';
import { Object3D, Object3DEventMap } from 'three';
import { PartsCategoriesModeViewer } from '../../ui/PartsCategoriesModelViewer';

export function usePartsCategoriesColumns<TData extends CategoryNode>({
  validationErrors,
  onValueChange,
  model,
}: {
  validationErrors: Record<string, string>;
  onValueChange: (value: { [key: string]: string }) => void;
  model: Object3D<Object3DEventMap> | undefined;
}) {
  return useMemo<MRT_ColumnDef<TData>[]>(
    () => [
      {
        accessorKey: 'thumbnail',
        header: '',
        size: 90,
        enableEditing: false,
        Cell: ({ row }: { row: MRT_Row<TData> }) => {
          if (row.original.itemType !== 'Part' || !row.original?.object3DName) return null;

          const part = model?.getObjectByName(row.original.object3DName)?.toJSON();
          return <PartsCategoriesModeViewer part={part} />;
        },
      },
      {
        accessorKey: 'name',
        header: 'Name',
        size: 250,
        Edit: ({ row }: { row: MRT_Row<TData> }) => (
          <EditPartsCategoriesCategoryNameInput
            error={validationErrors.name}
            onChange={(name) => onValueChange({ name })}
            initialCategoryName={row.original.name}
          />
        ),
      },
      {
        accessorKey: 'partNumber',
        header: 'Part Number',
        size: 200,
        enableEditing: false,
      },
      {
        accessorKey: 'itemType',
        header: 'Type',
        size: 100,
        Edit: () => 'Category',
      },
      {
        accessorKey: 'isHotspot',
        header: 'Hotspot',
        size: 100,
        Cell: ({ row }) => (row.original.isCategory ? 'Yes' : 'No'),
        Edit: () => 'Yes',
      },
    ],
    [validationErrors, onValueChange, model]
  );
}
